import React from 'react';
import {UsefulLinkItemComponent} from '../../../../components/useful-links/parts/useful-link-item/useful-link-item.component';
import {IRenderMenuItemOptions} from "../../../menu-items-common/renderer/menu-item.renderer.interface";
import {MenuItemRendererBase} from "../../../menu-items-common/renderer/menu-item-renderer-base";
import classNames from 'classnames';

export class GenericUsefulLinksMenuItemRenderer extends MenuItemRendererBase {
    protected _createReactElement(options?: IRenderMenuItemOptions): React.ReactElement {
        return (<UsefulLinkItemComponent
            key={this.key} menuItem={this}
            showSeparator={options.showSeparator}
            className={classNames(options.className, this.key)}
        />);
    }
}